import { createContext } from 'react';
import { FeatureFlag } from '@types';

export const FeatureFlagContext = createContext<FeatureFlag[]>([]);
